import React, { useEffect, useState } from "react";

import { useAppDispatch } from "../../../redux/useAppDispatch";
import { switchOffOrganization, switchOnOrganization } from "../../../redux/SettingModule/OrganizationsPage/OrganizationsPageAction";
import { Switch } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

function ActionColumnSettings(props: any) {
  const dispatch = useAppDispatch();
  const [switchStatus, setSwitchStatus] = useState(props.record.active);
  const loading = useSelector((state: RootState) => state.OrganizationsPageState.switchLoading);
  useEffect(() => {
    setSwitchStatus(props.record.active);
  }, [props.record.active]);
  return (
    <div className="d-flex gap-2 w-100 justify-content-center">
      {/* <InfoButton /> */}
      <Switch
        value={switchStatus}
        loading={loading}
        onChange={async (checked) => {
          if (checked) {
            try {
              await dispatch(switchOnOrganization({ id: props.record.idTenant })).unwrap();
              setSwitchStatus(true);
            } catch (error) {
              setSwitchStatus(false);
            }
          } else {
            try {
              await dispatch(switchOffOrganization({ id: props.record.idTenant })).unwrap();
              setSwitchStatus(false);
            } catch (error) {
              setSwitchStatus(true);
            }
          }
        }}
      />
      {/* <DeleteButton
        onClick={() => {
          dispatch(setCurrentRecord(props.record));
          dispatch(openDeleteOrganizationsModal());
        }}
      /> */}
    </div>
  );
}

export default ActionColumnSettings;
